/* eslint-disable max-len */
import Moveable from 'moveable';
import Selecto from 'selecto';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import DragHandle from '@/components/CustomAbles/DragHandle';
import DeleteHandle from '@/components/CustomAbles/DeleteHandle';
import DuplicateHandle from '@/components/CustomAbles/DuplicateHandle';
import CropHandle from '@/components/CustomAbles/CropHandle';
import DimensionViewer from '@/components/CustomAbles/DimensionViewer';
import { convertingDifferentMeasurementUnitIntoPx } from '@/components/Helper';
import { debounce, throttle } from 'lodash';

export default {

  methods: {
    bindClickEventToMoveableControls() {
      const movebaleDirections = document.getElementsByClassName('moveable-control moveable-direction');
      for (let i = 0; i < movebaleDirections.length; i += 1) {
        movebaleDirections[i].onmousedown = this.onMoveableDirectionClick;
      }
    },
    removeClickEventToMoveableControls() {
      const movebaleDirections = document.getElementsByClassName('moveable-control moveable-direction');
      for (let i = 0; i < movebaleDirections.length; i++) {
        movebaleDirections[i].removeEventListener('mousedown', this.onMoveableDirectionClick);
      }
    },

    toggleAlignmentGuides() {
      this.moveableObj.snappable = this.isAlignmentGuideOn;
    },
    updateElementSnapping() {
      let excludedElements = '';

      const objectToRemove = this.objectList.filter(e => e.isSelected === true);

      if (objectToRemove.length > 0) {
        objectToRemove.forEach((item) => {
          excludedElements += `:not([id='${item.Id}'])`;
        });
      }
      this.moveableObj.elementGuidelines = Array.from(document.querySelectorAll(`#canvas-wrapper .target${excludedElements}`));
    },
    initMoveableManager() {
      this.moveableObj = new Moveable(this.container.parentNode, {
        draggable:            true,
        target:               null,
        dragTarget:           document.querySelector('.drag-button'),
        container:            this.container.parentNode,
        dragArea:             true,
        resizable:            true, // { edge: ['e', 'w', 'n', 's'], renderDirections: ['e', 'w', 'n', 's'] },
        scalable:             true, // { edge: [], renderDirections: ['nw', 'ne', 'se', 'sw'] },
        rotatable:            true,
        origin:               false,
        rotationPosition:     'top',
        originDraggable:      true,
        originRelative:       true,
        passDragArea:         true,
        throttleDrag:         1,
        throttleResize:       0,
        throttleScale:        0,
        throttleRotate:       1,
        keepRatio:            false,
        edge:                 true,
        maxWidth:             'auto',
        maxHeight:            'auto',
        minHeight:            'auto',
        minWidth:             'auto',
        snappable:            true,
        snapContainer:        this.container,
        verticalGuidelines:   [],
        horizontalGuidelines: [],
        snapElement:          this.$store.getters.getSnappingEnabled,
        snapDirections:       {
          top:    true, left:   true, bottom: true, right:  true, center: true, middle: true,
        },
        elementSnapDirections: {
          top:    true, left:   true, bottom: true, right:  true, center: true, middle: true,
        },
        defaultGroupRotate: 0,
        snapThreshold:      0,
        snapGridWidth:      0,
        snapGridHeight:     0,
        isDisplaySnapDigit: true,
        snapDistFormat:     v => `${v}px`,
        ables:              [DuplicateHandle, DragHandle, DeleteHandle, CropHandle, DimensionViewer],
        props:              {
          dragHandle:      true,
          deleteHandle:    true,
          duplicateHandle: true,
          cropHandle:      false,
          dimensionViewer: true,
        },
        defaultGroupOrigin:         '50% 50%',
        triggerAblesSimultaneously: true,
      })
        .on('dragStart', this.onMoveableDragStart)
        .on('drag', this.onMoveableDrag)
        .on('dragEnd', this.onMoveableDragEnd)
      // group drag
        .on('dragGroup', this.onMoveableGroupDrag)
        .on('dragGroupEnd', this.onMoveableGroupDragEnd)
      // resize
        .on('resizeStart', this.onMoveableResizeStart)
        .on('resize', this.onMoveableResize)
        .on('resizeEnd', this.onMoveableResizeEnd)
        .on('scaleStart', this.onMoveableScaleStart)
        .on('scale', this.onMoveableScale)
        .on('scaleEnd', this.onMoveableScaleEnd)
      // Group Scale Events
        .on('scaleGroupStart', this.onMoveableScaleGroupStart)
        .on('scaleGroup', this.onMoveableScaleGroup)
        .on('scaleGroupEnd', this.onMoveableScaleGroupEnd)
      // rotate
        .on('rotateStart', this.onMoveableRotateStart)
        .on('rotate', this.onMoveableRotate)
        .on('rotateEnd', this.onMoveableRotateEnd)
        .on('rotateGroupStart', this.onMoveableRotateGroupStart)
        .on('rotateGroup', this.onMoveableRotateGroup)
        .on('rotateGroupEnd', this.onMoveableRotateGroupEnd);
    },

    setSnapThreshold(val) {
      this.moveableObj.snapHorizontalThreshold = val;
      this.moveableObj.snapVerticalThreshold   = val;
    },
    // Drag Event
    onMoveableDragStart(e) {
      this.moveableObj.snappable = this.$store.getters.getSnappingEnabled;
      const { X, Y }             = this.activeObject;
      e.set([X, Y]);
    },
    onMoveableDrag(e) {
      const { target } = e;
      if (target.id != this.activeObject.Id) {
        return;
      }
      e.target.style.transform = e.transform;
    },
    onMoveableDragEnd(e) {
      const { target } = e;
      if (target.id != this.activeObject.Id) {
        return;
      }
      const selectedObject                 = this.getObjectListObjectFromDomElement(target);
      [selectedObject.X, selectedObject.Y] = e.lastEvent.beforeTranslate;
      this.emitUndoRedoRequest('called by resize end');
    },

    onMoveableGroupDrag(e) {
      e.events.forEach((ev) => {
        ev.target.style.transform = ev.transform;
        console.log('dragging', this.moveableObj.snappable);
      });
    },
    onMoveableGroupDragEnd(e) {
      e.events.forEach((ev) => {
        if (ev.isDrag) {
          const selectedObject = this.objectList.find(element => element.Id == ev.target.id);
          selectedObject.X    += ev.lastEvent.beforeTranslate[0];
          selectedObject.Y    += ev.lastEvent.beforeTranslate[1];
        }
      });
      console.log('Emitting drag end');
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
    },
    // Resizing Event
    onMoveableResizeStart(e) {
      this.moveableObj.snappable = this.$store.getters.getSnappingEnabled;
      this.setSnapThreshold(0);
      if (e.target.getAttribute('data-type') == 'text') {
        const minHeight = parseInt(window.getComputedStyle(e.target.firstElementChild).getPropertyValue('height'), 10);
        e.setMin([0, minHeight + 10]);
      }
      const { target }           = e;
      this.moveableObj.keepRatio = (Math.abs(e.direction[0]) === Math.abs(e.direction[1])); // if resizing from corners, keep ratio fixed
      const { X, Y }             = this.getObjectListObjectFromDomElement(target);
      e.dragStart && e.dragStart.set([X, Y]);
      e.setOrigin(['%', '%']);
    },
    onMoveableResize(e) {
      const selectedObject  = this.objectList.find(elem => elem.Id == e.target.id);
      e.target.style.width  = `${e.width}px`;
      e.target.style.height = `${e.height}px`;
      if ((selectedObject.type === 'shape' || selectedObject.type === 'image') && (e.target.firstElementChild.tagName === 'svg' || selectedObject.ImageType === 'SVGImage')) {
        const width  = parseInt(e.width, 10);
        const height = parseInt(e.height, 10);
        if (width < 2 || height < 2) { return; }
        const w                                       = selectedObject.ImageType === 'SVGImage' ? convertingDifferentMeasurementUnitIntoPx(e.target.firstElementChild.firstChild.getAttribute('width')) : parseInt(e.target.firstElementChild.getAttribute('width'), 10);
        const h                                       = selectedObject.ImageType === 'SVGImage' ? convertingDifferentMeasurementUnitIntoPx(e.target.firstElementChild.firstChild.getAttribute('height')) : parseInt(e.target.firstElementChild.getAttribute('height'), 10);
        let scaleX                                    = width / w;
        scaleX                                        = scaleX || 1;
        let scaleY                                    = height / h;
        scaleY                                        = scaleY || 1;
        e.target.querySelector('svg').style.transform = `scale(${scaleX}, ${scaleY})`;
      }
      e.target.style.transform = e.drag.transform;
    },
    onMoveableResizeEnd(e) {
      this.setSnapThreshold(5);
      const selectedObject = this.objectList.find(elem => elem.Id == e.target.id);
      if ((selectedObject.type === 'shape' || selectedObject.type === 'image') && (e.target.firstElementChild.tagName === 'svg' || selectedObject.ImageType === 'SVGImage')) {
        const width  = parseInt(e.lastEvent.width, 10);
        const height = parseInt(e.lastEvent.height, 10);
        if (width < 2 || height < 2) { return; }
        const w    = selectedObject.ImageType === 'SVGImage' ? convertingDifferentMeasurementUnitIntoPx(e.target.firstElementChild.firstChild.getAttribute('width')) : parseInt(e.target.firstElementChild.getAttribute('width'), 10);
        const h    = selectedObject.ImageType === 'SVGImage' ? convertingDifferentMeasurementUnitIntoPx(e.target.firstElementChild.firstChild.getAttribute('height')) : parseInt(e.target.firstElementChild.getAttribute('height'), 10);
        let scaleX = width / w;
        scaleX     = scaleX || 1;
        let scaleY = height / h;
        scaleY     = scaleY || 1;

        if (selectedObject.shapeType === 'rectangle') {
          scaleY = 1;
          scaleX = 1;
        }
        if (selectedObject.ImageType === 'SVGImage') {
          selectedObject.SvgProperty.svgScaleX = scaleX;
          selectedObject.SvgProperty.svgScaleY = scaleY;
        } else {
          console.log(scaleY, scaleX);
          selectedObject.svgScaleX = scaleX;
          selectedObject.svgScaleY = scaleY;
        }
        const targetChild           = selectedObject.ImageType === 'SVGImage' ? e.target.firstElementChild.firstElementChild : e.target.firstElementChild;
        targetChild.style.transform = `scale(${scaleX},${scaleY})`;
        if (selectedObject.ImageType === 'SVGImage') {
          selectedObject.SvgProperty.content = targetChild.outerHTML;
          selectedObject.SvgProperty.style   = targetChild.style.transform;
        }
      }
      [selectedObject.X, selectedObject.Y] = e.lastEvent.drag.beforeTranslate;
      if (selectedObject.type === 'text' && selectedObject.Height > e.lastEvent.height) {
        const parentComputedHeight = window.getComputedStyle(e.target).getPropertyValue('height');
        const childComputedHeight  = window.getComputedStyle(e.target.firstElementChild).getPropertyValue('height');
        selectedObject.Height      = parseInt(parentComputedHeight, 10) > parseInt(childComputedHeight, 10) ? e.lastEvent.height : selectedObject.Height;
      } else {
        selectedObject.Width  = e.lastEvent.width;
        selectedObject.Height = e.lastEvent.height;
      }
      e.target.style.width  = `${selectedObject.Width}px`;
      e.target.style.height = `${selectedObject.Height}px`;

      e.target.style.transform = `scale(${selectedObject.scaleX},${selectedObject.scaleY}) rotate(${selectedObject.RotateDegree}deg)`;
      e.target.style.top       = `${selectedObject.Y}px`;
      e.target.style.left      = `${selectedObject.X}px`;
      if (selectedObject.shapeType === 'rectangle') {
        e.target.querySelector('svg').setAttribute('viewBox', `0 0 ${selectedObject.Width} ${selectedObject.Height}`);
        e.target.querySelector('svg').setAttribute('width', `${selectedObject.Width}`);
        e.target.querySelector('svg').setAttribute('height', `${selectedObject.Height}`);
        e.target.querySelector('rect').setAttribute('width', `${selectedObject.Width}`);
        e.target.querySelector('rect').setAttribute('height', `${selectedObject.Height}`);
      }
      if (selectedObject.shapeType === 'text') {
        this.setParentHeightAfterTextResize(e.target);
      }
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.$nextTick(() => {
        this.emitUndoRedoRequest('called by resize end');
      });
    },
    onMoveableScaleStart(e) {
      const { target }           = e;
      const selectedObject       = this.objectList.find(elem => elem.Id == target.id);
      this.moveableObj.keepRatio = (Math.abs(e.direction[0]) === Math.abs(e.direction[1]));
      this.moveableObj.snappable = this.$store.getters.getSnappingEnabled;
      this.setSnapThreshold(0);
      e.set([selectedObject.scaleX, selectedObject.scaleY]);
      e.setFixedDirection([0, 0]);
      if (target.getAttribute('data-type') !== 'text') {
        const directionX = e.direction[0] === 1 ? -1 : 1;
        const directionY = e.direction[1] === 1 ? -1 : 1;
        e.setFixedDirection([directionX, directionY]);
      }
    },
    onMoveableScale(e) {
      e.target.style.transform = e.drag.transform;
    },
    onMoveableScaleEnd(e) {
      const ev  = {};
      ev.events = [];
      ev.events.push(e);
      this.onMoveableScaleGroupEnd(ev);
      console.log('Scale End called');
      this.emitUndoRedoRequest('called by Scale end');
      this.setSnapThreshold(5);
    },
    onMoveableScaleGroupStart(e) {
      this.moveableObj.snappable = this.$store.getters.getSnappingEnabled;
      this.setSnapThreshold(0);
      e.events.forEach((ev) => {
        const selectedObject            = this.objectList.find(elem => elem.Id == ev.target.id);
        ev.target.style.transformOrigin = 'top left';
        if (selectedObject.type == 'text' || selectedObject.type == 'shape') { ev.target.style.transformOrigin = 'center center'; }
      });
    },
    onMoveableScaleGroup(e) {
      this.moveableObj.keepRatio = true;
      e.events.forEach((ev) => {
        ev.target.style.transform = ev.drag.transform;
      });
    },
    onMoveableScaleGroupEnd(e) {
      e.events.forEach((ev) => {
        const selectedObject = this.objectList.find(elem => elem.Id == ev.target.id);
        let scaleX           = ev.lastEvent.scale[0];
        let scaleY           = ev.lastEvent.scale[1];
        let newWidth         = scaleX * selectedObject.Width;
        let newHeight        = scaleY * selectedObject.Height;
        if ((selectedObject.type === 'shape' || selectedObject.type === 'image') && (ev.target.firstElementChild.tagName === 'svg' || selectedObject.ImageType === 'SVGImage')) {
          const targetChild = selectedObject.ImageType === 'SVGImage' ? ev.target.firstElementChild.firstElementChild : ev.target.firstElementChild;
          newWidth          = Math.ceil(scaleX * parseInt(window.getComputedStyle(ev.target).getPropertyValue('width'), 10));
          newHeight         = Math.ceil(scaleY * parseInt(window.getComputedStyle(ev.target).getPropertyValue('height'), 10));
          const childWidth  = parseInt(window.getComputedStyle(targetChild).getPropertyValue('width'), 10);
          const childHeight = parseInt(window.getComputedStyle(targetChild).getPropertyValue('height'), 10);
          scaleX            = newWidth / childWidth;
          scaleY            = newHeight / childHeight;
          if (selectedObject.shapeType === 'rectangle') {
            scaleY = 1;
            scaleX = 1;
          }
          if (selectedObject.ImageType === 'SVGImage') {
            selectedObject.SvgProperty.svgScaleX = scaleX;
            selectedObject.SvgProperty.svgScaleY = scaleY;
          } else {
            console.log(scaleY, scaleX);
            selectedObject.svgScaleX = scaleX;
            selectedObject.svgScaleY = scaleY;
          }

          targetChild.style.transform = `scale(${scaleX},${scaleY})`;
          if (selectedObject.ImageType === 'SVGImage') {
            selectedObject.SvgProperty.content = targetChild.outerHTML;
            selectedObject.SvgProperty.style   = targetChild.style.transform;
          }
        }

        if (selectedObject.type === 'text') {
          selectedObject.Y     += ev.lastEvent.drag.beforeTranslate[1];
          selectedObject.X     += ev.lastEvent.drag.beforeTranslate[0];
          selectedObject.scaleX = ev.lastEvent.scale[0];
          selectedObject.scaleY = ev.lastEvent.scale[1];
        } else {
          let xOffset = 0;
          let yOffset = 0;
          if (selectedObject.type === 'shape') {
            xOffset = (selectedObject.Width - newWidth) / 2;
            yOffset = (selectedObject.Height - newHeight) / 2;
          }
          selectedObject.Y += ev.lastEvent.drag.beforeTranslate[1] + Math.ceil(yOffset);
          selectedObject.X += ev.lastEvent.drag.beforeTranslate[0] + Math.ceil(xOffset);
          // ev.target.style.transformOrigin = '';
          selectedObject.Width  = newWidth;
          selectedObject.Height = newHeight;
        }
      });
      this.setSnapThreshold(5);
      console.log('Emitting scale end');
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
    },

    setParentHeightAfterTextResize(element) {
      const selectedObject       = this.getObjectListObjectFromDomElement(element);
      const parentComputedHeight = window.getComputedStyle(element).getPropertyValue('height');
      const childComputedHeight  = window.getComputedStyle(element.firstElementChild).getPropertyValue('height');
      if (parseInt(parentComputedHeight, 10) < parseInt(childComputedHeight, 10)) {
        selectedObject.Height = parseInt(childComputedHeight, 10) + 2;
        setTimeout(() => {
          EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
        }, 0);
      }
    },


    // Rotating Event
    onMoveableRotateStart(e) {
      this.setSnapThreshold(0);
      const { RotateDegree } = this.getObjectListObjectFromDomElement(e.target);
      console.log('Setting fixed direction', RotateDegree);
      // e.set(RotateDegree);
      e.setFixedDirection([0, 0]);
    },
    onMoveableRotate(e) {
      console.log('Rotating');
      e.target.style.transform = e.drag.transform;
    },
    onMoveableRotateEnd(ev) {
      const selectedObject        = this.objectList.find(elem => elem.Id == ev.target.id);
      selectedObject.Y           += ev.lastEvent.drag.beforeTranslate[1];
      selectedObject.X           += ev.lastEvent.drag.beforeTranslate[0];
      selectedObject.RotateDegree = ev.lastEvent.rotate;

      ev.target.style.transform = `scale(${selectedObject.scaleX},${selectedObject.scaleY}) rotate(${selectedObject.RotateDegree}deg)`;
      ev.target.style.top       = `${selectedObject.Y}px`;
      ev.target.style.left      = `${selectedObject.X}px`;

      this.setSnapThreshold(5);
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.emitUndoRedoRequest('Called by rotate end');
    },
    onMoveableRotateGroupStart(e) {
      this.setSnapThreshold(0);
      e.setFixedDirection([0, 0]);
    },
    onMoveableRotateGroup(e) {
      e.events.forEach((ev) => {
        ev.target.style.transform = ev.drag.transform;
      });
    },
    onMoveableRotateGroupEnd(e) {
      this.setSnapThreshold(5);
      e.events.forEach((ev) => {
        const selectedObject        = this.objectList.find(elem => elem.Id == ev.target.id);
        selectedObject.Y           += ev.lastEvent.drag.beforeTranslate[1];
        selectedObject.X           += ev.lastEvent.drag.beforeTranslate[0];
        selectedObject.RotateDegree = ev.lastEvent.beforeRotate;

        ev.target.style.transform = `scale(${selectedObject.scaleX},${selectedObject.scaleY}) rotate(${selectedObject.RotateDegree}deg)`;
        ev.target.style.top       = `${selectedObject.Y}px`;
        ev.target.style.left      = `${selectedObject.X}px`;
      });

      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.emitUndoRedoRequest('Called by group rotate end');
    },
    // movable events Ended
    // Initializing Selecto
    initSelectManager() {
      this.selectO = new Selecto({
        container:            this.container.parentNode,
        selectableTargets:    ['.html-container .target'],
        selectFromInside:     false,
        toggleContinueSelect: 'shift',
      })
        .on('dragStart', this.onSelectoDragStart)
        .on('select', this.onSelectoSelect)
        .on('selectEnd', this.onSelectoSelectEnd);
    },

    onSelectoDragStart(e) {
      EventBus.$emit(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION);
      this.$store.commit('activeProduct/updateIsTrimmedVideoPlaying', false);
      this.$store.commit('activeProduct/updateISTrimmingEnable', false);
      this.$store.commit('activeProduct/updatePageAnimationPanel', false);
      const { moveableObj } = this;

      const { target } = e.inputEvent;
      if (moveableObj.isMoveableElement(target) || target.classList.contains('extended-button')) {
        e.stop();
      }
    },
    onSelectoSelect(e) {
      this.activeObject     = null;
      this.isObjectSelected = true;
    },
    onSelectoSelectEnd(e) {
      const { moveableObj }                       = this;
      const { selected, inputEvent, isDragStart } = e;
      if (selected.length > 0) {
        if (!selected[0].classList.contains('focus-text-editor')) {
          this.makeIsSelectedKeyFalse();

          e.selected.forEach((selectedElem) => {
            const object = this.objectList.find(elem => elem.Id == selectedElem.id);
            if (!object) { console.log('visibility issue', object, selectedElem.id); }
            object.isSelected = object.IsVisible;
          });
          this.activeObject = this.objectList.find(elem => elem.isSelected);


          if (isDragStart) {
            e.inputEvent.preventDefault();
            moveableObj.dragStart(inputEvent);
          }
          EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.SELECTED, this.activeObject);
          EventBus.$emit('unSelectAudioLayer');
        }
        setTimeout(() => {
          this.moveableObj.dragTarget =  document.querySelector('#drag-button');
        }, 400);
      } else {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      }
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.objectList);
      this.onObjectUpdated();
      if (e.removed.length > 0 && e.removed[0].dataset.type === 'text') {
        this.disableTinymce();
      }
      // this.updateElementSnapping();
      this.updateMoveableControls(e);
    },
    updateMoveableControls(e) {
      this.moveableObj.resizable = true;
      this.moveableObj.scalable  = false;
      this.moveableObj.keepRatio = false;

      this.moveableObj.props.cropHandle     = (this.activeObject && this.activeObject.type === 'image' && this.activeObject.ImageType === 'Image' && this.activeObject.DefaultImageUrl.split(/[#?]/)[0].split('.').pop().trim() != 'svg');
      this.moveableObj.verticalGuidelines   = this.$store.getters.getVerticalGuides.concat([0, this.width]).map(num => Math.ceil(num * this.$store.getters.getZoomLevel / 100));
      this.moveableObj.horizontalGuidelines = this.$store.getters.getHorizontalGuides.concat([0, this.height]).map(num => Math.ceil(num * this.$store.getters.getZoomLevel / 100)).concat([0, this.width]);
      this.moveableObj.snapElement          = this.$store.getters.getSnappingEnabled;
      this.moveableObj.snappable            = this.$store.getters.getSnappingEnabled;
      this.moveableObj.renderDirections     = ['nw', 'n', 'ne', 'w', 'e', 'sw', 's', 'se'];
      this.selectO.toggleContinueSelect     = ['shift'];


      if (e.selected.length > 1) {
        this.moveableObj.resizable        = false;
        this.moveableObj.keepRatio        = true;
        this.moveableObj.scalable         = true;// { edge: [], renderDirections: ['nw', 'ne', 'se', 'sw'] };
        this.moveableObj.renderDirections = ['nw', 'ne', 'se', 'sw'];
      }
      if (e.selected.length === 1) {
        if (this.activeObject.type === 'video') {
          this.moveableObj.renderDirections = ['nw', 'ne', 'sw', 'se'];
        }
        if (this.activeObject.type === 'text') {
          this.moveableObj.resizable = { edge: ['e', 'w', 'n', 's'], renderDirections: ['e', 'w', 'n', 's'] };
          this.moveableObj.scalable  = { edge: [], renderDirections: ['nw', 'ne', 'se', 'sw'] };
        }
      }
    },

    // selecto events Ended
    makeIsSelectedKeyFalse() {
      this.objectList.forEach((object) => {
        object.isSelected = false;
      });
    },
    getObjectListObjectFromDomElement(element) {
      try {
        const index = element.dataset.elementindex;
        return this.objectList[index];
      } catch (ex) {
        console.log('Exception while getting Object Index @getObjectListObjectFromDomElement');
        console.log(ex.message);
        console.log(element);
      }
    },
    onClearSelection() {
      this.$store.commit('activeProduct/updateIsTrimmedVideoPlaying', false);
      this.$store.commit('activeProduct/updateISTrimmingEnable', false);
      this.$store.commit('activeProduct/updatePageAnimationPanel', false);
      this.$store.commit('activeProduct/updateDisplayAnimationPanel', false);
      this.$store.commit('activeProduct/UpdateIsAudioTrimOn', false);
      EventBus.$emit('unSelectAudioLayer');
      EventBus.$emit('toggleAudioLeftSectionAccordion', false);
      EventBus.$emit('onObjectSelectedCleared');
      this.objectList.forEach((item) => {
        item.isSelected = false;
      });
      this.targets = [];
      this.selectO.setSelectedTargets([]);
      this.selectO.trigger('select');
      this.disableTinymce();
    },
    disableTinymce() {
      const element = document.querySelector('.focus-text-editor ', '.fmce-edit-focus');
      if (element) {
        this.setParentHeightAfterTextResize(element);
        element.classList.remove('focus-text-editor');
        window.getSelection().removeAllRanges();
        const tempObject          = this.objectList[element.dataset.elementindex];
        tempObject.isEditorEnable = false;
        // element.setAttribute('contenteditable','false')
        tempObject.Value    = tempObject.modifiedHtml;
        const activeElement = document.getElementById(tempObject.Id);
        activeElement && (activeElement.style.overflowY = 'initial');
        activeElement && (activeElement.classList.remove('focus-text-editor'));
        this.activeEditor = null;
        setTimeout(() => {
          this.removeFocusFromTextEditor(element);
          if (typeof this.activeObject !== 'undefined') {
            EventBus.$emit('onObjectSelected', this.activeObject);
          }
        }, 0);
      }
    },
    emitUndoRedoRequest(data) {
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, data);
    },
    removeFocusFromTextEditor(element) {
      element.blur();
    },
    onObjectUpdated: throttle(function () {
      this.$nextTick(() => {
        if (!this.activeObject) {
          return;
        }

        const nsHandle = (this.activeObject.Width * this.activeObject.scaleX * (this.scale / 100) < 90) ? 0 : 1;
        const ewHandle = (this.activeObject.Height * this.activeObject.scaleY * (this.scale / 100) < 75) ? 0 : 1;
        this.$store.commit('setMovableHandle', { ns: nsHandle, ew: ewHandle });
        this.moveableObj.updateTarget();
      });
    }),

    selectingCanvasObjectFromRightPanel(id) {
      const clickEvent     = new MouseEvent('click', {
        view:       window,
        bubbles:    true,
        cancelable: true,
      });
      const objectToSelect = this.objectList.find(elem => elem.Id == id);
      if (objectToSelect) {
        this.selectO.clickTarget(clickEvent, document.getElementById(id));
      }
    },
  },
};
